/** Public build-time configuration (safe to ship: URL + publishable/anon key only). */
// "same-origin": the site itself proxies /functions, /auth and /storage (local demo behind a tunnel).
const rawUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const url = (rawUrl === 'same-origin' ? globalThis.location?.origin : rawUrl)?.replace(/\/$/, '');
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Visible in the console of a misconfigured deployment; the UI shows its own error state.
  console.error('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set');
}

export const SUPABASE_URL = url ?? '';
export const SUPABASE_ANON_KEY = anonKey ?? '';
export const FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;

export function mediaUrl(path: string, version?: string): string {
  const v = version ? `?v=${encodeURIComponent(version)}` : '';
  return `${SUPABASE_URL}/storage/v1/object/public/tenant-media/${path}${v}`;
}
